import { useQuery } from '@tanstack/react-query';
import etfPriceService from "@etfPriceService";

export function useFetchETFPrice(symbol: string, exchange?: string) {
  return useQuery({
    queryKey: ['etf-price', symbol, exchange],
    queryFn: async () => {
      return await etfPriceService.fetchETFPrice({ symbol, exchange });
    },
    enabled: !!symbol,
    staleTime: 5 * 60 * 1000, // 5 min cache
    // Retry up to 3 times with exponential backoff (1s, 2s, 4s).
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * Math.pow(2, attempt), 30000),
  });
}
